import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import Layout from "../../components/Layout";
import { FormTypes } from "../../utils/models";
import Forms1040 from "./components/Forms1040";
import FormsW2 from "./components/FormsW2";
import FormsSchedule1 from "./components/FormsSchedule1";
import FormsScheduleC from "./components/FormsScheduleC";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { RootState } from "../../store/index";
import { Dispatch } from "redux";
import { push } from "redux-first-history";
import LineLoader from "../../components/Loaders/LineLoader/LineLoader";
import { taxSlice } from "../../store/reducer/tax";
import ErrorFallback from "../../components/ErrorFallback";

interface UploadContainerProps {
  taxState: RootState["tax"];
  dispatch: Dispatch<any>;
}

export const typeNameMap = {
  [FormTypes.t1040]: "Federal Form 1040",
  [FormTypes.w2]: "W-2 Form(s)",
  [FormTypes.schedule1]: "Schedule 1 Form",
  [FormTypes.scheduleC]: "Schedule C Form(s)",
} ;

const UploadContainer = ({ taxState, dispatch }: UploadContainerProps) => {
  const { type } = useParams() as { type: FormTypes };
  const taxReturn = taxState.tax_return;

  useEffect(() => {
    if (!taxReturn) {
      dispatch(taxSlice.actions.fetchTaxReturnRequest());
      return;
    }
    dispatch(push("/upload/IRS1040"));
    dispatch(taxSlice.actions.proceedToNextStep({form: FormTypes.t1040, balance: false}));
  }, [!taxReturn, dispatch]);

  useEffect(() => { 
    document.title = import.meta.env.VITE_APP_NAME + ' - ' + typeNameMap[type];
  }, [type]);

  const renderForms = () => {
    switch (type) {
      case FormTypes.t1040:
        return <Forms1040 />;
      case FormTypes.w2:
        return <FormsW2 />;
      case FormTypes.schedule1:
        return <FormsSchedule1 />;
      case FormTypes.scheduleC:
        return <FormsScheduleC />;
    }
  };

  return (
    <Layout>
      {taxReturn ? (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          {renderForms()}
        </ErrorBoundary>
      ) : (
        <LineLoader />
      )}
    </Layout>
  );
};

const mapStateToProps = (state: RootState) => ({
  taxState: state.tax,
});

export default connect(mapStateToProps)(UploadContainer);
